import { useState, useEffect } from "react";
import { navData, ctaLink } from "../data/mock";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#1a1c1b]/95 backdrop-blur-md border-b border-[#3f4816]/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[87.5rem] mx-auto px-10 flex items-center justify-between h-[76px]">
        {/* Brand — Logo + Name */}
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3.5 cursor-pointer"
        >
          <img
            src={navData.logo}
            alt="Rahul Taneja"
            className="w-12 h-12 rounded-full object-cover object-top border-2 border-[#3f4816]/50"
          />
          <div className="flex flex-col">
            <span
              className="text-[#dfddd6] font-bold text-base leading-tight tracking-tight"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {navData.brand}
            </span>
            <span
              className="text-[#888680] text-[11px] font-medium uppercase tracking-widest leading-tight mt-0.5"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {navData.brandSub}
            </span>
          </div>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-1">
          {navData.links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              className="text-[#888680] text-sm font-medium px-5 py-3 rounded-full transition-all duration-300 hover:text-[#dfddd6] hover:bg-[#3f4816]/15"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#final-cta"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#final-cta");
            }}
            className="ml-4 bg-[#d9fb06] text-[#1a1c1b] font-semibold text-sm px-6 py-3 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 active:scale-[0.98] uppercase tracking-tight inline-flex items-center"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {navData.ctaText}
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-[#dfddd6] p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-[#1a1c1b]/98 backdrop-blur-md ${
          mobileOpen ? "max-h-[400px] border-b border-[#3f4816]/30" : "max-h-0"
        }`}
      >
        <div className="px-6 pb-6 pt-2 flex flex-col gap-2">
          {navData.links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              className="text-[#888680] text-base font-medium py-3 px-4 rounded-lg transition-colors hover:text-[#dfddd6] hover:bg-[#3f4816]/15"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#final-cta"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector("#final-cta");
              if (el) el.scrollIntoView({ behavior: "smooth" });
              setMobileOpen(false);
            }}
            className="mt-2 bg-[#d9fb06] text-[#1a1c1b] font-semibold text-sm px-6 py-4 rounded-full uppercase tracking-tight text-center"
          >
            {navData.ctaText}
          </a>
        </div>
      </div>
    </nav>
  );
};
